<script setup lang="ts">
import ButtonPrimary from '@/shared/components/button/ButtonPrimary.vue';
import { useRouter } from 'vue-router';
import ProgressFrame from './layout/ProgressFrame.vue';
import ProgressStepsList from './progress-steps/ProgressStepsList.vue';

const router = useRouter();

function goToConfirmTerms() {
  router.push({ name: 'ConfirmTerms' });
}
</script>

<template>
  <ProgressFrame pageClass="section-page">
    <template #title>Getting Started</template>
    <template #subTitle>
      Before we begin, here is the process we’ll go through to commission the
      SolShare.
    </template>
    <div class="content">
      <ProgressStepsList :displayOnly="true" />
      <ButtonPrimary
        block
        class="next-button"
        @click="goToConfirmTerms"
        data-tn="getting-started-lets-begin"
      >
        Let's begin
      </ButtonPrimary>
    </div>
  </ProgressFrame>
</template>

<style lang="less" scoped>
.next-button {
  margin-top: 75px;
}
</style>
